import { DocumentType } from './document-type.model';
import { JtiDocumentAdditionalInfo, JtiDocumentAdditionalInfoForPartySelect, JtiDocumentAdditionalInfoForBoolean, JtiDocumentAdditionalInfoForText, JtiDocumentAdditionalInfoForDate, JtiDocumentAdditionalInfoForCurrency, JtiDocumentAdditionalInfoForCodeList, JtiDocumentAdditionalInfoForNewAddress } from '.';
import { JtiDocumentAdditionalInfoForAttorneySelect } from './jti-document-additional-info-for-attorney-select.model';
import { JtiDocumentAdditionalInfoForSelfRepresented } from './jti-document-additional-info-for-self-represented.model';

export class JtiSubsequentDocumentType extends DocumentType
{
  jtiDocumentAdditionalInfo: JtiDocumentAdditionalInfo[];

  jtiDocumentAdditionalInfoForAsTo: JtiDocumentAdditionalInfoForPartySelect;
  jtiDocumentAdditionalInfoForNotAsTo: JtiDocumentAdditionalInfoForPartySelect;
  jtiDocumentAdditionalInfoForFiledBy: JtiDocumentAdditionalInfoForPartySelect;
  jtiDocumentAdditionalInfoForNewAsTo: JtiDocumentAdditionalInfoForPartySelect;
  jtiDocumentAdditionalInfoForNewFiledBy: JtiDocumentAdditionalInfoForPartySelect;
  jtiDocumentAdditionalInfoForExistingAttorney: JtiDocumentAdditionalInfoForAttorneySelect;
  jtiDocumentAdditionalInfoForNewAttorney: JtiDocumentAdditionalInfoForAttorneySelect;
  jtiDocumentAdditionalInfoForNewAddress: JtiDocumentAdditionalInfoForNewAddress;
  jtiDocumentAdditionalInfoForSelfRepresented: JtiDocumentAdditionalInfoForSelfRepresented;
  jtiDocumentAdditionalInfoForBooleans: JtiDocumentAdditionalInfoForBoolean[];
  jtiDocumentAdditionalInfoForTexts: JtiDocumentAdditionalInfoForText[];
  jtiDocumentAdditionalInfoForDates: JtiDocumentAdditionalInfoForDate[];
  jtiDocumentAdditionalInfoForCurrencies: JtiDocumentAdditionalInfoForCurrency[];
  jtiDocumentAdditionalInfoForCodeLists: JtiDocumentAdditionalInfoForCodeList[];
  
}
